'use client';

import { PaybackAccountDataFetchProvider } from '@packages/order/src/components/Payback/PaybackAccountDataFetchProvider';
import { PaybackConnected } from '@packages/order/src/components/Payback/PaybackConnected';
import { PaybackDisconnected } from '@packages/order/src/components/Payback/PaybackDisconnected';
import { PaybackReauthenticate } from '@packages/order/src/components/Payback/PaybackReauthenticate';
import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import { OfflineNotification } from '../OfflineNotification/OfflineNotification';
import { usePaybackConnectionStatus } from './hooks/usePaybackConnectionStatus';

export const PaybackPage = () => {
  const {
    isOffline,
    isDisconnected,
    isInactive,
    isEstablished,
    isReauthenticationNeeded,
    isLoading,
  } = usePaybackConnectionStatus();

  if (isLoading) {
    return <Skeleton className="my-2 h-32 w-full" />;
  }

  if (isOffline) {
    return <OfflineNotification />;
  }

  return (
    <>
      {isDisconnected && <PaybackDisconnected enableSignIn />}
      {isInactive && <PaybackDisconnected enableSignIn={false} />}
      {isEstablished && (
        <PaybackAccountDataFetchProvider>
          <PaybackConnected />
        </PaybackAccountDataFetchProvider>
      )}
      {isReauthenticationNeeded && <PaybackReauthenticate />}
    </>
  );
};
// eslint-disable-next-line import-x/no-default-export
export default PaybackPage;
